module.exports = __webpack_public_path__ + "static/award-netzwelt-e6fcffb7a9e3ffed94db4584bf28201f.jpg";